import { z } from "zod";

export const changeReasonCreateSchema = z.object({
  name: z.string().min(1, "Name is required").max(120),
  description: z.string().max(500).nullable().optional(),
});

export const changeReasonUpdateSchema = changeReasonCreateSchema.partial();

/**
 * Move a reason one step up or down in the admin-controlled ordering. The
 * server renumbers `sort_order` around the swap, so the client only ever asks
 * for a direction — never a raw sort_order value.
 */
export const changeReasonReorderSchema = z.object({
  direction: z.enum(["up", "down"]),
});

export type ChangeReasonCreateInput = z.infer<typeof changeReasonCreateSchema>;
export type ChangeReasonUpdateInput = z.infer<typeof changeReasonUpdateSchema>;
